<template>
  <div class="LuckDrawBox" >
	  <div class="LuckDrawTop" >
		  <div class="luckArrowLeft"  @click="$router.go(-1)">
			  <img src="../../assets/img/icon/Arrowleft.png" alt="">
		  </div>
	  </div>
	  <div class="LuckDrawContent" >
          <div class="chooseMode" >
             请选择抽奖方式
		  </div>
		  <div class="chooseRadio" >
			 <van-radio-group v-model="radio">
				<van-radio name="1">新人注册赠送{{luckDrawInfo.registerNum}}次，剩余{{luckDrawInfo.registLeftNum}}次</van-radio>
				<van-radio name="2">注册用户每日赠送{{luckDrawInfo.loginNum}}次，剩余{{luckDrawInfo.loginLeftNum}}次</van-radio>
				<van-radio name="3">重消币购买抽奖次数，剩余{{luckDrawInfo.pointNum}}次</van-radio>
			 </van-radio-group>
		  </div>
		  <div class="currencyBuy" v-show="radio == 3" >
			  <div class="currencyBox" >
				<div class="buynum" >
					<van-cell-group>
						<van-field v-model="inpointNum" placeholder="请输入重消币数量" />
					</van-cell-group>
					<span>1次抽奖<br>/{{luckDrawInfo.pointBuyNum}}个重消币</span>
				</div>
				<p class="balance" >重消币余额：{{luckDrawInfo.point}}</p>	
			 </div>
			 <div class="buyBtn" >
               <button @click="buyPoint()" >购买</button>				 
			 </div>
		  </div>
		  <div class="luckFrequency" >
              <van-field v-model="takeNum" label="参与次数" />
		  </div>
	  </div>
	  <div class="LuckNotice" >
		  <div class="noticeBox"  >
			  <div class="imgHorn" >
				  <img src="../../assets/img/default/horn.png" alt="">
			  </div>
			  <div :class="{marquee_top:animate}" >
				 <div class="noticeList" v-for="(item,i) in luckNotice" :key="i" >
				  <span>恭喜用户{{item}}中奖！</span>
			 	 </div>
			  </div>
		  </div>
	  </div>
	  <div class="LuckDrawExplain" >
          <!-- <div class="explainTitle" >
             抽奖活动目前提供两类产品
		  </div> -->
		  <div class="explainContent" >
               <!-- <div class="explainCTitle" >
                  <i>1</i>
				  <span>如何参加抽奖活动？</span>	
			   </div> -->
			   <p v-html="luckDrawInfo.luckNotice" ></p>
			   <!-- <div class="content" ></div> -->
		  </div>
		  <!-- <div class="dividingLine" ></div>
		    <div class="explainContent" >
               <div class="explainCTitle" >
                  <i>2</i>
				  <span>抽奖奖品有什么？</span>	
			   </div>
			   <div class="content" >
				   <p>{{luckDrawInfo.luckNotice}}</p>
			   </div>
		  </div> -->
	  </div>
	  <div class="LuckDrawBtn" >
         <button @click="LuckDrawResult()" >
			 立即抽奖
		 </button>
	  </div>

	  <van-overlay :show="noLuckShow"  >
			<div class="noLuckwrapper" @click.stop>
				<div v-if="winPrize" >
					<img  src="../../assets/img/default/LuckDrawResult.png" width="50%" alt="">
					<button  @click="winPrizeGoods()"  >去领奖</button>
				</div>
				<div v-else >
					<img   class="noPrize" src="../../assets/img/default/LuckDrawResult1.png" width="50%" alt="">
					<img @click="noLuckShow = false" class="noLuckclose" src="../../assets/img/icon/luckClose.png" alt="">
				</div>
			</div>
	</van-overlay>

	
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast,Dialog } from 'vant';
Vue.use(Toast);
export default {
  name: 'LuckDraw',
  data() {
    return {
		 radio: '1',
		 noLuckShow:false,
		 winPrize:true,
		 value:"",
		 animate:false,
		 takeNum:0,
		 inpointNum:0,
		 luckDrawInfo:{},
		 luckids : this.$route.query.luckid,
		 luckDrawWay : '',
		 luckGoods:{},
		 luckNotice:[],
		 goodsId:this.$route.query.goods_id
    }
  },

   beforeRouteLeave(to, from, next) {
	//this.back用来判断是点击提交以后的后退 还是点击了后退按钮
	
      if(to.name!='index') {
        next()
      } else if(this.winPrize&&this.noLuckShow){
                //弹出提示框
        Dialog.confirm({
          message: '您将放弃该奖品',
          confirmButtonText: '继续领奖',
          cancelButtonText: '不要了',
        }).then(() => {
                  //点击继续填写
          next(false)
        }).catch(() => {
                  //点击退出
          next()
        });
      }else{
		   next()
	  }
    },

  components: {},
  mounted(){
	  if(localStorage.getItem('isLogin') == 'true'){
			this.getLuckDraw();
		 }else{
		  this.$router.push({path:'/login'});
		 }
	  
	  let that = this;
    const timer = setInterval(() => {
      this.animate = true;
      setTimeout(() => {
        that.luckNotice.push(this.luckNotice[0]);
        that.luckNotice.shift();
        that.animate = false;
        console.log(Math.random());
      }, 1000);
    }, 3000);
    // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer);
    });

  },
  methods: {
  	winPrizeGoods(){
		 this.$router.push({
			 path : '/luckDrawAddress',
			 query : {
				 luckGoodsInfo : this.luckGoods,
				 goods_id:this.goodsId
			 }
		 })
	},
	getLuckDraw(){
		this.getRequest(`members/luck/info`).then(res => {
			console.log(res.data.data)
			this.luckDrawInfo = res.data.data;
				res.data.data.winnerList.forEach((e,i) => {
					this.luckNotice.push(e.mobile+i);
					console.log(e.mobile+i)
				})
			})
	},
	buyPoint(){
		if(this.luckDrawInfo.point>(this.inpointNum*this.luckDrawInfo.pointBuyNum)){
			this.getRequest(`members/luck/pointBuyLuck`,{num:this.inpointNum}).then(res => {
			 this.getLuckDraw();
		})
		}else{
			Toast.fail('重消币余额不足,请充值');
		}
		
	},
	LuckDrawResult(){
		if(this.takeNum == 0){
			Toast.fail('请输入抽奖次数');
		}else{
		if(this.radio == 1){
			if(this.luckDrawInfo.registLeftNum < this.takeNum || this.luckDrawInfo.registLeftNum == 0){
				Toast.fail('抽奖次数不足');
				debugger
			}else{
				this.luckDrawWay = 'register'
				this.atOnceLuckDraw()
			}
		}else if(this.radio == 2){
			if(this.luckDrawInfo.loginLeftNum < this.takeNum){
				debugger
				Toast.fail('抽奖次数不足');
			}else{
				this.luckDrawWay = 'login'
				this.atOnceLuckDraw()
			}
		}else{
			if(this.luckDrawInfo.pointNum < this.takeNum){
				debugger
				Toast.fail('抽奖次数不足');
			}else{
				this.luckDrawWay = 'point'
				this.atOnceLuckDraw()
			}
		}
	  }
	},
		
	atOnceLuckDraw(){
		let param = {
			doNum:this.takeNum,
			luckId:this.luckids,
			way : this.luckDrawWay
		}
		this.getRequest(`members/luck/doDrow`,param).then(res => {
			if(res.data.data.result == 1){
				this.noLuckShow = true
				this.winPrize = true;
			}else if(res.data.data.result == 2){
				this.noLuckShow = true
				this.winPrize = false;
			}else{
				this.noLuckShow = false
				Toast(res.data.data.msg);
			}
			this.luckGoods = res.data.data.goods;
			 this.getLuckDraw();
		})
	}
		
  }
}
</script>

<style scoped lang='less'>
   .LuckDrawBox{
	   position: relative;
	   background-color: #FFF3E1;
	   padding-bottom: 130px;
	.LuckDrawTop{
		background-image: url(../../assets/img/default/LuckDrawBg.png);
		background-size: cover;
		width: 100%;
		height: 646px;
		position: relative;
		.luckArrowLeft{
			 position: absolute;
			 left: 38px;
			 top: 50px;
			img{
				width: 20px;
				height: 36px;
			} 
		}
	}
	.LuckDrawContent{
		position: relative;
		width: 90%;
		height: auto;
		margin: 0 auto;
		background-color: #fff;
		padding:30px;
		margin-top: -380px;
		.chooseMode{
			background-image: url(../../assets/img/default/LuckDrawTitle.png);
			background-size: 100% 100%;
			width: 348px;
			height: 62px;
			line-height: 62px;
			margin: 0 auto;
			text-align: center;
			color: #AA2300;
			font-size: 15px;
            font-weight:500;
		}
		.chooseRadio{
			margin: 40px 0;
		  /deep/	.van-radio{
				margin: 20px 0;
			/deep/	.van-radio__icon{
				 line-height: 34px;
				 height: 30px;
				/deep/	.van-icon{
					width: 34px;
					height: 34px;
					font-size: 12px;
					}
				}
			/deep/	.van-radio__icon--checked{
				/deep/	.van-icon{
						background-color:transparent;
						background:linear-gradient(to right,#CD0F02,#E52F23,#FF511C);
						border-color:#FF511C;
                      }
				}
			/deep/	.van-radio__label{
					color: #333333;
					font-size: 28px;
				}
			}
		}
		.currencyBuy{
			width: 92%;
			margin:24px 0 20px 8%;
			padding-bottom: 30px;
			position: relative;
			
			.currencyBox{
				background-color: #FDF2F1;
				padding: 28px 20px;
				border-radius:10px;
			.buynum{
				display: flex;
				.van-cell-group{
					width: 356px;
					border-radius:30px;
					/deep/ .van-cell{
						background:rgba(255,255,255,1);
						border-radius:30px;
						height: 59px;
						line-height: 59px;
						padding: 0 10px;
					/deep/	input{
							height: 59px;
							font-size: 26px;
							text-align: center;
						}
						/deep/ input::placeholder{
						  color: #DDDDDD;
						  font-size: 26px;
						  text-align: center;
						}
					}
				}
				span{
					flex: 1;
					text-align: center;
					color: #333333;
					font-size: 24px;
				}
			}
			.balance{
				color: #FF5B10;
				font-size: 24px;
				padding-left: 100px;
				margin-top: 15px;
			}
		  }
		  .buyBtn{
			  margin-top: 36px;
			  text-align: center;
			  button{
				 background: linear-gradient(to right,#FFB630,#FE7B01);
				 width: 217px;
				 height: 74px;
				 text-align: center;
				 line-height: 74px;
				 color: #fff;
				 font-size: 28px;
				 border-radius: 40px;       
			  }
		  }
		}
		.luckFrequency{
			position: relative;
			padding-top: 20px;
			&::before{
				content: "";
				position: absolute;
				width: 100%;
				height:2px;
				background-color: #f2f2f2;
				top: 0;
				left: 0;
			}
			/deep/ .van-field__label{
			   color: #040404;
			   font-size: 24px;
			   width: 100px;
			   line-height: 59px;
			   margin-right: 40px;
			}
			/deep/ .van-cell__value{
			/deep/	input{
                   background-color:rgba(242,242,242,1);
					border-radius:30px; 
					height: 59px; 
					padding: 0 20px;
				}
			}
		}
	}
	  .LuckNotice{
		width: 90%;
		margin: 0 auto;
		box-shadow:0px 10px 18px 0px rgba(3,3,3,0.1);
		height: 88px;
		line-height: 88px;
     	 overflow: hidden;
		.noticeBox{
			background-color: #FFF3CE;
			padding: 0 10%;
			display: flex;
			justify-content: center;
			.imgHorn{
				width: 30px;
				height: 30px;
				margin-right: 18px;
				margin-top: 30px;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.noticeList{
				width: 100%;
				span{
					color: #FF5B10;
					font-size: 30px;
				}
			}
			.marquee_top {
			transition: all 0.5s;
			margin-top: -90px;
			}
		}
		}
	.LuckDrawExplain{
		width: 90%;
		background-color: #fff;
		height:auto;
		margin-top: 33px;
		margin-left: 5%;
		padding: 21px 35px;
		.explainTitle{
          	background-image: url(../../assets/img/default/LuckDrawTitle.png);
			background-size: 100% 100%;
			width: 348px;
			height: 62px;
			line-height: 62px;
			margin: 0 auto;
			text-align: center;
			color: #AA2300;
			font-size: 15px;
			font-weight:500;
			margin-bottom: 40px;
		}
		.explainContent{
			margin: 20px 0;
			.explainCTitle{
				text-align: center;
				i{
					display: inline-block;
                   	width:32px;
					height:32px;
					border-radius: 50%;
					background:rgba(132,68,0,1);
					font-weight:500;
					color:rgba(255,255,255,1);
					line-height:32px;
					font-size:26px;
					text-align: center;
					font-style: normal;
					margin-right: 5px;

				}
				span{
					font-weight:500;
					color:rgba(132,68,0,1);
					font-size: 30px;
					vertical-align: bottom;
				}
			}
			.content{
				width: 80%;
				margin: 0 auto;
				p{
					font-weight:400;
					color:rgba(51,51,51,1);
					line-height:37px;
					font-size: 26px;
					margin-top: 37px;
					text-indent: 40px;
				}
				
			}
		}
		.dividingLine{
			width: 100%;
			height: 2px;
			border-bottom: dotted 1px #030303;
			margin: 40px 0;
		}
	}
	.LuckDrawBtn{
		background-color: #fff;
		padding:12px 78px;
		position: fixed;
		bottom: 0;
		width: 100%;
		button{
			background: linear-gradient(to right,#F24C0B,#F2170C);
			width: 100%;
			height: 88px;
			line-height:88px;
			letter-spacing:2px;
			font-size:36px;
			color: #fff;
			border-radius: 40px;
		}
	}
	.noLuckwrapper{
	   width: 70%;
	   margin: 0 auto;
	   position: relative;
	   .noLuckclose{
		 width: 60px;
		 height: 60px;
		 margin: 0 auto;
		  margin-top: 75px;
	   }
	   button{
		  	width:217px;
			height:74px;
			background:rgba(254,180,1,1);
			border-radius:37px;
			text-align: center;
			line-height: 74px;
			color: #fff;
			position:absolute;
			bottom: 50px;
			left: 156px;
	   }
	   .noPrize{
		   margin-top: 150px;
	   }
	}	
 }
</style>


